<template>
  <PageLayoutWrapper
    page="departments/_id/courses"
    :props="{...$props, courses }"
  >
    <BaseTable
      :rows="courses"
      resource-name="Courses"
      @select="goToCourse"
    >
      <template #header>
        <th class="th">Code</th>
        <th class="th">Name</th>
        <th class="th">Description</th>
      </template>
      <template #default="{ row: course }">
        <td>
          <NuxtLink
            :to="getCourseUrl(course)"
            :aria-label="`Link to ${course.code || course.subjectCode + course.courseNumber || ''} course`"
          >
            {{ course.code || course.subjectCode + course.courseNumber }}
          </NuxtLink>
        </td>
        <td>
          {{ courseNameWithFallbacks(course) }}
        </td>
        <td :title="course.description">
          {{ getShortDescription(course.description) }}
        </td>
      </template>
    </BaseTable>
  </PageLayoutWrapper>
</template>

<script>
import { mapGetters } from 'vuex'
import _sortBy from 'lodash/sortBy'
import { getShortDescription } from '@/utils/generalUtils'
import PageLayoutWrapper from '@/components/PageLayoutWrapper'
import CoursesService from '@/services/courses'
import useCourses from '@/composables/useCourses'
import { courseNameWithFallbacks } from '@/utils/entityNames'

export default {
  components: {
    PageLayoutWrapper,
  },
  props: {
    department: {
      type: Object,
      required: true,
    },
    availableColumns: {
      type: Array,
      default: () => [
        {
          id: 'Code',
        },
        {
          id: 'Name',
        },
        {
          id: 'Description',
        },
      ],
    },
  },
  setup(props, { root }) {
    const { goToCourse, getCourseUrl } = useCourses(root)
    return {
      getCourseUrl,
      goToCourse,
      courseNameWithFallbacks,
    }
  },
  head() {
    return {
      title: `${this.department.displayName} Department Courses | ${
        this.catalogWideMetaTitle
      }`,
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: `${this.department.displayName} Department Courses | ${
            this.catalogWideMetaTitle
          }`,
        },
      ],
    }
  },
  computed: {
    ...mapGetters('settings', ['catalogWideMetaTitle']),
  },
  async asyncData({ params, $bugsnag, $axios, redirect, store }) {
    const api = new CoursesService($axios, store)

    try {
      const { data } = await api.getCourses({
        department: params.id,
      })
      let courses = data
      courses = _sortBy(Object.values(courses), ['code', 'name', 'longName'])

      return { courses }
    } catch (e) {
      console.error(e)
      $bugsnag.notify(e)
      redirect('/404')
    }
  },
  methods: {
    getShortDescription,
  },
}
</script>
